import { render, staticRenderFns } from "./selectStaff.vue?vue&type=template&id=e5580b10&"
import script from "./selectStaff.vue?vue&type=script&lang=js&"
export * from "./selectStaff.vue?vue&type=script&lang=js&"
import style0 from "./selectStaff.vue?vue&type=style&index=0&id=e5580b10&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports